import { cn } from '@/lib/utils';

import type { DateBoxView } from '../date-box';

export type EventChipProps = {
  view: DateBoxView;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  colorHex?: string;
  disabled?: boolean;
  children: React.ReactNode;
};

export function EventChip(props: EventChipProps) {
  const inlineStyle = props.colorHex
    ? {
        borderColor: props.colorHex,
        backgroundColor: `${props.colorHex}18`,
        color: props.colorHex,
      }
    : undefined;

  return (
    <button
      type="button"
      className={cn(
        'cursor-pointer rounded-sm border px-1.5 py-0.5 text-left text-[11px] leading-tight font-medium hover:brightness-90 disabled:cursor-not-allowed',
        !props.colorHex && 'border-blue-500 bg-blue-50 text-blue-700',
        props.view === 'month' && 'truncate',
        props.className,
      )}
      style={inlineStyle}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}
